module.exports = __webpack_public_path__ + "img/payment system logos.4e366fa0.png";